import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { TOKEN_KEY } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const tk = localStorage.getItem(TOKEN_KEY);
    if (!tk) { setMe(null); setLoading(false); return null; }
    try {
      const r = await api.get("/auth/me");
      setMe(r.data);
      return r.data;
    } catch {
      setMe(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setMe(null);
    window.location.href = "/login";
  }, []);

  return (
    <Ctx.Provider value={{ me, loading, refresh, logout, setMe }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
